import { useInfiniteQuery as rqUseInfiniteQuery, } from 'react-query';
import { useTribeClient } from '../useTribeClient';
export const useInfiniteQuery = (queryKey, queryFn, options) => {
    const { ready } = useTribeClient();
    return rqUseInfiniteQuery(queryKey, queryFn, {
        enabled: !ready ? false : options === null || options === void 0 ? void 0 : options.enabled,
        getNextPageParam: lastPage => {
            var _a;
            // Return undefined to indicate there is no next page available.
            if (!((_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pageInfo) === null || _a === void 0 ? void 0 : _a.hasNextPage))
                return undefined;
            return lastPage.pageInfo.endCursor || undefined;
        },
        ...options,
    });
};
//# sourceMappingURL=useInfiniteQuery.js.map